export default "__VITE_PUBLIC_ASSET__7fe066ff__"